import { Component, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-grid-form-item',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="grid-item-content">
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .grid-item-content {
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class GridFormItemComponent {
  @Input() span: number | 'full' = 1;
  @Input() customSpan?: string;

  hasCustomSpan = false;
  private autoSpanValue: number | 'full' = 1;

  @HostBinding('class')
  get hostClasses(): string {
    let classes = 'grid-item';

    if (!this.customSpan) {
      const spanValue = this.autoSpanValue === 'full' ? 'full' : this.autoSpanValue;
      classes += ` col-span-${spanValue}`;
    }

    return classes;
  }

  @HostBinding('style.gridColumn')
  get gridColumn(): string | null {
    if (this.customSpan) {
      return this.customSpan;
    }

    if (this.autoSpanValue === 'full') {
      return '1 / -1';
    }

    return null;
  }

  setAutoSpan(span: number | 'full') {
    this.autoSpanValue = span;
  }
}
